var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useStateWithMutators } from '@rad/hooks';
import FormClient from '../forms/client';
import { requireToken } from '../../utility/general';
import { postObjectJson } from '../../utility/request';
import Card from '../components/card';
import ButtonLoading from '../components/button.loading';
const clientEmpty = {
    client_firstname: '',
    client_lastname: '',
    client_businessname: '',
    client_no_address: false,
    client_tax_exempt: false,
    client_address: '',
    client_address2: '',
    client_city: '',
    client_state: null,
    client_zip: '',
    client_contacts: [],
    client_notes: [],
    client_notes_new: [],
};
const clientNew = () => JSON.parse(JSON.stringify(clientEmpty));
export default (props) => {
    const token = requireToken('merchant');
    const [state, mutators] = useStateWithMutators({
        'successMessage': '',
        'errors': null,
        'client': clientNew(),
    });
    const clientCreate = (f) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            mutators.errors(null);
            mutators.successMessage('');
            yield postObjectJson(`/merchants/${token.merchant.id}/clients/create`, Object.assign({}, state.client), {
                'error': (x) => __awaiter(void 0, void 0, void 0, function* () { return mutators.errors(yield x.json()); }),
                'success': (result) => __awaiter(void 0, void 0, void 0, function* () {
                    if (!!f) {
                        f(result);
                    }
                    else {
                        mutators.client._(clientNew());
                        mutators.successMessage('Customer Created');
                        // Clear success message after 3 seconds
                        setTimeout(() => {
                            mutators.successMessage('');
                        }, 3000);
                    }
                }),
            });
        }
        finally {
        }
    });
    const clientCreateAndView = () => clientCreate((result) => window.location.hash = `#/clients/${result.id}`);
    return _jsx(_Fragment, { children: _jsx("div", { className: "d-flex w-100 justify-content-center", children: _jsx("div", { className: "column", style: { 'maxWidth': '800px' }, children: _jsxs(Card, { title: null, children: [_jsx(FormClient, { noselect: true, client: null, errors: ((state.errors || [])).reduce((agg, x) => (Object.assign(Object.assign({}, agg), { [x.field]: x.message })), {}), onChange: () => { }, onChange_client: () => { }, client_firstname: state.client.client_firstname, onChange_client_firstname: mutators.client.client_firstname, client_lastname: state.client.client_lastname, onChange_client_lastname: mutators.client.client_lastname, client_businessname: state.client.client_businessname, onChange_client_businessname: mutators.client.client_businessname, client_no_address: state.client.client_no_address, onChange_client_no_address: mutators.client.client_no_address, client_tax_exempt: state.client.client_tax_exempt, onChange_client_tax_exempt: mutators.client.client_tax_exempt, client_address: state.client.client_address, onChange_client_address: mutators.client.client_address, client_address2: state.client.client_address2, onChange_client_address2: mutators.client.client_address2, client_city: state.client.client_city, onChange_client_city: mutators.client.client_city, client_state: state.client.client_state, onChange_client_state: mutators.client.client_state, client_zip: state.client.client_zip, onChange_client_zip: mutators.client.client_zip, client_contacts: state.client.client_contacts, onChange_client_contacts: mutators.client.client_contacts, client_notes: state.client.client_notes, onChange_client_notes: mutators.client.client_notes, client_notes_new: state.client.client_notes_new, onChange_client_notes_new: mutators.client.client_notes_new }), !!state.successMessage && _jsx("div", { className: "alert alert-success text-center mb-3", role: "alert", children: state.successMessage }), _jsxs("div", { className: "text-center mb-2", children: [_jsx("div", { className: "mb-2", children: _jsx(ButtonLoading, { color: "primary", onClick: clientCreate, children: "Create" }) }), _jsx("div", { children: _jsx(ButtonLoading, { color: "purple", onClick: clientCreateAndView, children: "Create and View" }) })] })] }) }) }) });
};
